import { Modal, Button } from 'react-bootstrap';
import React from 'react';
import SimpleDataTables from '../Common/SimpleDataTables';

const CustomerTrackingModal = ({ data, show, handleClose }) => {

    
    console.log('data', data);
    const columns = [
        {
            label: 'Product Id',
            field: 'productId',
        },
        {
            label: 'Name',
            field: 'productName',
        },
        {
            label: 'Description',
            field: 'productDescription',
        },
        {
            label: 'Category',
            field: 'productType',
        },
        {
            label: 'Quantity',
            field: 'productQuantity',
        },
        {
            label: 'Date added',
            field: 'date',
        }
    ];


    return (
        <Modal show={show} onHide={handleClose} 
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Product Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    data && data.length === 0  ? (
                        <p>No Products Data Found</p>
                    ) : <SimpleDataTables columns={columns} rows={data} /> 
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomerTrackingModal;

